

export class UserLicenseDetailsUpdateInput implements IUserLicenseDetailsUpdateInput {
    /** The auto-generated id of the user license details master */
    userLicenseId!: number;
    /** The auto-generated id of the user master */
    userId!: number;
    /** The license issue date with 10 character limit */
    licenseIssueDate!: string;
    /** The license activation date with 10 character limit */
    licenseActivationDate!: string;
    /** The license expiry date with 10 character limit */
    licenseExpiryDate!: string;
    /** The license extended date with 10 character limit */
    licenseExtendDate!: string;
    /** Expiry message in days */
    showExpiryMessage!: number;
    /** The remark with 500 character limit */
    remark!: string;

    constructor(data?: IUserLicenseDetailsUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userLicenseId = _data["userLicenseId"];
            this.userId = _data["userId"];
            this.licenseIssueDate = _data["licenseIssueDate"];
            this.licenseActivationDate = _data["licenseActivationDate"];
            this.licenseExpiryDate = _data["licenseExpiryDate"];
            this.licenseExtendDate = _data["licenseExtendDate"];
            this.showExpiryMessage = _data["showExpiryMessage"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): UserLicenseDetailsUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserLicenseDetailsUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userLicenseId"] = this.userLicenseId;
        data["userId"] = this.userId;
        data["licenseIssueDate"] = this.licenseIssueDate;
        data["licenseActivationDate"] = this.licenseActivationDate;
        data["licenseExpiryDate"] = this.licenseExpiryDate;
        data["licenseExtendDate"] = this.licenseExtendDate;
        data["showExpiryMessage"] = this.showExpiryMessage;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IUserLicenseDetailsUpdateInput {
    /** The auto-generated id of the user license details master */
    userLicenseId: number;
    /** The auto-generated id of the user master */
    userId: number;
    /** The license issue date with 10 character limit */
    licenseIssueDate: string;
    /** The license activation date with 10 character limit */
    licenseActivationDate: string;
    /** The license expiry date with 10 character limit */
    licenseExpiryDate: string;
    /** The license extended date with 10 character limit */
    licenseExtendDate: string;
    /** Expiry message in days */
    showExpiryMessage: number;
    /** The remark with 500 character limit */
    remark: string;
}

